<template>
  <form @submit.prevent="submit">
    <!-- Contact -->
    <fieldset class="form-group">
      <label class="flex justify-between form-label">
        Contact
      </label>

      <div class="relative border border-gray-300 divide-y divide-gray-300 rounded shadow-sm">
        <div class="relative focus-within:z-50">
          <input name="name" type="text" class="border-transparent rounded-none rounded-t form-input" placeholder="Company Name (If Applicable)" v-model="form.name" :disabled="disabled">
        </div>
        <div class="relative focus-within:z-50">
          <input name="contact_name" type="text" class="border-transparent rounded-none form-input" placeholder="Contact Person Name" v-model="form.contact_name" :disabled="disabled">
        </div>
        <div class="relative focus-within:z-50">
          <input type="tel" name="contact_phone" class="border-transparent rounded-none form-input" placeholder="Contact Person Phone" v-model="form.contact_phone" :disabled="disabled">
        </div>
        <div class="relative focus-within:z-50">
          <input type="email" name="contact_email" class="border-transparent rounded-none rounded-b form-input" autocomplete="disabled" placeholder="Contact Person Email (Optional)" v-model="form.contact_email" :disabled="disabled">
        </div>
      </div>
      <validations :errors="errors" field="contact_name" />
      <validations :errors="errors" field="contact_email" />
      <validations :errors="errors" field="contact_phone" />
    </fieldset>

    <!-- Address -->
    <fieldset class="form-group">
      <label for="address" class="form-label">Address</label>
      <div class="relative border border-gray-300 divide-y divide-gray-300 rounded shadow-sm">
        <div class="relative focus-within:z-50">
          <AddressAutocomplete
            :id="`autocomplete-${form.id}`"
            name="address"
            ref="address"
            input-class="border-transparent rounded-b-none form-input"
            placeholder="Street Address"
            @placechanged="getAddressData"
            @inputChange="changeAddressData"
            :disabled="disabled"
            :initial-value="form.address_1" />
        </div>
        <div class="relative focus-within:z-50">
          <input type="text" placeholder="Apartment/Complex/Shop No." class="border-transparent rounded-none form-input" autocomplete="disabled" v-model="form.address_2" :disabled="disabled">
        </div>
        <div class="grid grid-cols-6 divide-x divide-gray-300">
          <div class="relative col-span-4 focus-within:z-50">
            <input type="text" placeholder="City" class="col-span-4 border-transparent rounded-none form-input" autocomplete="disabled" v-model="form.city" :disabled="disabled">
          </div>
          <div class="relative col-span-2 focus-within:z-50">
            <input type="text" placeholder="Zip/Postal Code" class="col-span-2 border-transparent rounded-none form-input" autocomplete="disabled" v-model="form.zip" :disabled="disabled">
          </div>
        </div>
        <div class="relative focus-within:z-50">
          <country-select placeholder="Country or Region" class="border-transparent rounded-t-none form-select" v-model="form.country" :disabled="disabled" />
        </div>
      </div>
      <validations :errors="errors" field="address_1" />
      <validations :errors="errors" field="city" />
      <validations :errors="errors" field="zip" />
      <validations :errors="errors" field="country" />
    </fieldset>

    <div class="flex justify-between mt-4" v-if="!disabled">
      <button class="btn btn-accent" v-submitting="submitting">
        Save Changes
      </button>
    </div>
  </form>
</template>

<script>
import AddressAutocomplete from '@/components/AddressAutocomplete'

const emptyAddressForm = {
  name: '',
  contact_company: '',
  contact_name: '',
  contact_phone: '',
  contact_email: '',
  address_1: '',
  address_2: '',
  city: '',
  zip: '',
  country: '',
  latitude: null,
  longitude: null
}

export default {
  name: 'CustomerAddressForm',

  components: {
    AddressAutocomplete
  },

  props: {
    address: {
      type: Object
    },

    mode: {
      type: String,
      default: 'create'
    },

    disabled: {
      type: Boolean
    }
  },

  created () {
    if (this.mode === 'create') {
      this.form = JSON.parse(JSON.stringify(emptyAddressForm))
    } else {
      this.form = JSON.parse(JSON.stringify(this.address))
    }
  },

  data () {
    return {
      submitting: false,
      form: {},
      errors: []
    }
  },

  methods: {
    changeAddressData (event) {
      this.form.address_1 = event.newVal
    },

    getAddressData ({ addressData, placeResultData }) {
      for (let component of placeResultData.address_components) {
        if (component.types.includes('country')) {
          this.form.country = component.short_name
        }
      }
      this.form.formatted_address = placeResultData.formatted_address
      this.form.city = addressData.locality
      this.form.zip = addressData.postal_code
      this.form.latitude = addressData.latitude
      this.form.longitude = addressData.longitude
      this.form.address_1 = placeResultData.formatted_address.split(',')[0] + ',' + placeResultData.formatted_address.split(',')[1]
      this.$refs.address.$refs.address.$el.value = this.form.address_1
    },

    async submit () {
      try {
        this.submitting = true
        if (this.mode === 'create') {
          const { data } = await this.$api.post(`portal/${this.$store.state.portal.subdomain}/customer/addresses`, this.form)
          this.$emit('success', data.address)
        } else {
          const { data } = await this.$api.patch(`portal/${this.$store.state.portal.subdomain}/customer/addresses/${this.address.id}`, this.form)
          this.$emit('success', data.address)
        }
        this.form = emptyAddressForm
      } catch (error) {
        console.error(error)
        this.errors = error.response.data.errors ? error.response.data.errors : []
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>